import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyBULI47Qc52Mh69PQUaR1jbwvbpDZTeqQ8",
  authDomain: "franzspitzer-80618.firebaseapp.com",
  databaseURL: "https://franzspitzer-80618-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "franzspitzer-80618",
  storageBucket: "franzspitzer-80618.firebasestorage.app",
  messagingSenderId: "862754637770",
  appId: "1:862754637770:web:3bc662c2d5600cb945f133",
  measurementId: "G-ZP78H7K01X"
};

const app = initializeApp(firebaseConfig);
const appCheck = initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider('6Lffm5kqAAAAAHXIaCapXIChyuVoy-DGV2AR4UoN'), isTokenAutoRefreshEnabled: true });
const database = getDatabase(app);

if (window.location.hostname === "localhost") {
  // Connect Firebase emulators for development environment
  connectDatabaseEmulator(database, "localhost", 9000);
}

export { 
  app as firebase,
  appCheck,
  database,
};